<script lang="ts">
  import ItemList from '$components/pages/ItemList/ItemList.svelte';
  import type { PageData } from './$types';

  export let data: PageData;
  let { pageData, data: templateData } = data;
  $: ({ pageData, data: templateData } = data);

  import listConfig from './list.config';
</script>

<svelte:component this={ItemList} data={templateData} config={listConfig(templateData)} />
